import styled from 'styled-components'

export const SocialMediaContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: ${({ margin }) => margin || '30px 0 50px'};
`

export const SocialMediaListContainer = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
`

export const SocialMediaList = styled.li`
  border-right: ${({ borderRight }) => borderRight || '1px solid #DDE0E3'};
  padding: 0 10px;
  height: 21px;
  color: gray;

  &:last-of-type {
    border-right: none;
  }
`
